function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 0.5V44.5",
  stroke: "#E0E0E0",
  strokeDasharray: "2 2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 0.5V44.5",
  stroke: "#E0E0E0",
  strokeDasharray: "2 2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51 0.5V44.5",
  stroke: "#E0E0E0",
  strokeDasharray: "2 2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M75 0.5V44.5",
  stroke: "#E0E0E0",
  strokeDasharray: "2 2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M99 0.5V44.5",
  stroke: "#E0E0E0",
  strokeDasharray: "2 2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M123 0.5V44.5",
  stroke: "#E0E0E0",
  strokeDasharray: "2 2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1 36L27.5 22.5L50.5 36L76 22.5H99L125 9",
  stroke: "#BDBDBD",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.5,
  cy: 22.5,
  r: 3.5,
  fill: "#BDBDBD",
  stroke: "white",
  strokeWidth: 2
});

const SvgNoDataGraph = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 126,
  height: 45,
  viewBox: "0 0 126 45",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoDataGraph, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-data-graph.210ba76e.svg";
export { ForwardRef as ReactComponent };